export const routePlanningFormConstants = {
  routeName: "name",
  color: "color",
  description: "description",
  boundName: "name",
  boundType: "boundType",
  values: "values",
}

export enum BoundTypeEnum {
  postal_code = "postal_code",
  locality = "locality",
  user_drawn_area = "user_drawn_area",
}
